import { useContext } from 'react';
import { AnimationsContext } from '../contexts/AnimationsContext';
import animations from '../theme/animations';

// This hook returns animations if enabled, otherwise returns empty objects
export const useAnimationStyles = () => {
  const context = useContext(AnimationsContext);

  // If context is not available (provider not wrapped), default to enabled
  const enabled = context?.animationsEnabled ?? true;

  if (!enabled) {
    // Return empty objects/functions when animations are disabled
    return {
      fadeIn: {},
      slideDown: {},
      slideUp: () => ({}),
      scaleIn: () => ({}),
      staggeredCard: () => ({}),
      slideLeft: () => ({}),
      slideRight: () => ({}),
      hoverLift: {},
      hoverLiftScale: {},
      buttonPress: {},
      iconButtonSpin: {},
      listItemSlide: () => ({}),
      tableRowFade: () => ({}),
    };
  }

  return animations;
};
